import React from 'react';
import { Status } from '../../utils/types';
interface StatusBadgeProps {
  status: Status;
  size?: 'sm' | 'md';
}
export function StatusBadge({
  status,
  size = 'md'
}: StatusBadgeProps) {
  const styles = {
    a_planifier: 'bg-gray-100 text-gray-700 border-gray-200',
    planifie: 'bg-blue-100 text-blue-800 border-blue-200',
    en_preparation: 'bg-indigo-100 text-indigo-800 border-indigo-200',
    en_cours: 'bg-teal-100 text-teal-800 border-teal-200',
    bloque: 'bg-red-100 text-red-800 border-red-200',
    en_attente_client: 'bg-amber-100 text-amber-800 border-amber-200',
    termine: 'bg-green-100 text-green-800 border-green-200',
    facturable: 'bg-purple-100 text-purple-800 border-purple-200',
    cloture: 'bg-slate-100 text-slate-700 border-slate-200'
  };
  const labels = {
    a_planifier: 'À planifier',
    planifie: 'Planifié',
    en_preparation: 'En préparation',
    en_cours: 'En cours',
    bloque: 'Bloqué',
    en_attente_client: 'Attente client',
    termine: 'Terminé',
    facturable: 'Facturable',
    cloture: 'Clôturé'
  };
  const sizeStyles = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-2.5 py-1 text-xs'
  };
  return <span className={`inline-flex items-center rounded-full font-medium border ${styles[status]} ${sizeStyles[size]}`} data-id="element-243">
      {labels[status]}
    </span>;
}